import React, { Component } from 'react';
import getExcelHelper from '../../../Common/Helpers/GetExcelHelper'
import DatosEjecucionProceso from './DatosEjecucionProceso';

class ModalProcesos extends Component {
    constructor (props){
        super(props);
        this.state={
            flecha:true
        }
        this.invertirOrdenProc = this.invertirOrdenProc.bind(this);
    }
    
    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
    }

    invertirOrdenProc(){
        this.setState({flecha:!this.state.flecha})
    }

    render() {
        
        const {administradora,proceso} = this.props;

        let logo = "";
        let backColor = "";
        let inconoTipo = "";
        let leyendaTipo ="";

        let datosProcesos = JSON.parse(JSON.stringify(this.props.datosProcesos));

        if(!this.state.flecha){
            datosProcesos = datosProcesos.reverse();
        }


        switch(administradora){
            case 1:
                logo = " image-visa-logo procesoLogo modalProcesosLogo"
            break;
    
            case 2:
                logo = " image-cabal-logo procesoLogo modalProcesosLogo"
            break;
    
            case 3:
                logo = " image-mastercard-logo procesoLogo modalProcesosLogo"
            break;
        }

        switch (proceso.ColorResultado){
            case "VERDE" :
                backColor= ' procesosVerde'
            break;
            
            case "ROJO" :
                backColor= ' procesosRojo'
            break;
            
            case "AZUL" :
                backColor= ' procesosAzul'
            break;
            
            case "AMARILLO" :
                backColor= ' procesosAmarillo'
            break;
        }

        switch (proceso.TipoProceso){
            case "P" :
                inconoTipo= 'icono-gear2'
                leyendaTipo= 'Proceso'
            break;
            
            case "I" :
                inconoTipo= 'icono-input2'
                leyendaTipo= 'Archivo Input'
            break;
            
            case "O" :
                inconoTipo= 'icono-output2'
                leyendaTipo= 'Archivo Output'
            break;
        }
        
        return (
            <div className='modalContainer'>
                <div className='modalProcesosOut'>
                   <div className='modalProcesosHeader'>
                       <div className='procesoColumnRight'>
                            <div className={logo}></div>
                            <label onClick={()=>{this.props.limpiarTablero("CajasProcesos");this.props.mostrarModal(3,false)}} className='ti-close clickable modalProcesosClose'></label>
                       </div>
                       <div className='modalProcesosInfoContainer'>
                            <div className={'modalProcesosInfo' + backColor}>
                                <div className='modalProcesosInfoLeft'>
                                    <div className={inconoTipo}></div>
                                    <div className="modalProcesosInfoText">
                                        <div className='CreditCardIcon'>{proceso.DescripcionProceso}</div>
                                        <div>{leyendaTipo}</div>
                                    </div>
                                </div>
                                <div className='modalProcesosInfoRight'>
                                    <div className='CreditCardIcon'>{proceso.DescripcionProcesoEstado}</div>
                                    <div>{proceso.CantidadRegistrosOriginal + " Registros totales"}</div>
                                </div>
                            </div>
                       </div>
                   </div>
                   <div className='modalProcesosBody'>
                        <DatosEjecucionProceso validarProcesoEnEjecucion={this.props.validarProcesoEnEjecucion} mostrarModal={this.props.mostrarModal} getErroresProceso={this.props.getErroresProceso} invertirOrdenProc={this.invertirOrdenProc} flecha={this.state.flecha} datosProcesos={datosProcesos} descargarExcel={() => this.props.descargarExcel(this.props.datosProceso, this.props.datosProcesosEncabezado)}/>
                   </div>
                   <div className='modalProcesosFooter'>
                       <button onClick={()=>{this.props.limpiarTablero("CajasProcesos");this.props.mostrarModal(3,false)}} className="btn btn-secondary">Cerrar</button>
                   </div>
                </div>
            </div>
        );
    }
}

export default ModalProcesos;